<mat-expansion-panel
  #form
  [ngClass]="{ 'mb-2': isMobile }"
  [expanded]="!isMobile ? true : false"
  [disabled]="!isMobile"
>
  <mat-expansion-panel-header *ngIf="!aditional">
    <mat-panel-title class="uk-text-subheading container-search-customer-title">
      <span>Información del cliente</span>
      <mat-icon
        *ngIf="isMobile"
        [ngClass]="myform.valid ? 'icon-primary' : 'icon-warn'">
        account_circle
      </mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form action="" [formGroup]="myform" [ngClass]="{ 'form-container': !aditional }">
    <div class="cart-customer">
      <div class="row">
        <mat-form-field class="col-6 col-md-3" [ngClass]="{ 'col-lg-2': aditional }">
          <mat-label>Tipo de documento</mat-label>
          <mat-select
            id="customerDocumentType"
            formControlName="documentType"
            disableOptionCentering="true"
            (selectionChange)="onChangeSelectdocumentType($event.value)"
          >
            <mat-option *ngFor="let item of document" [value]="item['value']">{{
              item['text']
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-6 col-md-3" [ngClass]="{ 'col-lg-2': aditional }">
          <mat-label>Escriba el número *</mat-label>
          <input
            matInput
            type="text"
            id="customerDocumentNumber"
            name="number"
            formControlName="identityDocument"
            [maxlength]="getTypeNum().max"
            #number
            (keyup.enter)="onClickGetCustomer(number.value)"
            (blur)="onClickGetCustomer(number.value)"
            autocomplete="off"
            [minlength]="getTypeNum().min"
          />
          <mat-icon class="search-icon" matSuffix (click)="onClickGetCustomer(number.value)">search</mat-icon>
          <mat-error
            class="mat-error"
            *ngIf="
              myform.get('identityDocument').invalid &&
              (myform.get('identityDocument').dirty ||
                myform.get('identityDocument').touched)
            "
            >{{ getErrorMessage() }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-12 col-md-3"
        [ngClass]="{'col-md-6': myform.controls['documentType'].value === 'RUC'}">
        <mat-label>{{myform.controls['documentType'].value !== 'RUC'
                ? 'Escriba el nombre *'
                : 'Razón social *'}}</mat-label>
          <input
            matInput
            type="text"
            id="customerName"
            [name]="myform.controls['documentType'].value !== 'RUC' ? 'alphabetical' : 'ruc'"
            formControlName="name"
            (keypress)="validateInput($event)"
            [readonly]="!isActive"
            autocomplete="off"
            maxlength="160"
          />
          <mat-error *ngFor="let validation of validation_messages.name">
            <span
              class="mat-error"
              *ngIf="
                myform.get('name').hasError(validation.type) &&
                (myform.get('name').dirty || myform.get('name').touched)
              "
              >{{ validation.message }}
            </span>
          </mat-error>
        </mat-form-field>
        <mat-form-field
          class="col-12 col-md-3"
          *ngIf="myform.controls['documentType'].value !== 'RUC'"
        >
        <mat-label>Escriba los apellidos *</mat-label>
          <input
            matInput
            type="text"
            id="customerLastName"
            name="alphabetical"
            formControlName="lastName"
            maxlength="160"
            (keypress)="validateInput($event)"
            [readonly]="!isActive"
            autocomplete="off"
          />
          <mat-error
            *ngFor="let validation of validation_messages.lastName"
            class="container-error-input"
          >
            <span
              class="mat-error"
              *ngIf="
                myform.get('lastName').hasError(validation.type) &&
                (myform.get('lastName').dirty || myform.get('lastName').touched)
              "
            >
              {{ validation.message }}
            </span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-6 col-md-3" [ngClass]="{ 'col-lg-2': aditional }">
          <mat-label>Escriba el teléfono *</mat-label>
          <input
            matInput
            type="text"
            id="customerPhone"
            name="number"
            formControlName="phone"
            maxlength="this.maxlengthCellNumber"
            (keypress)="validateInput($event)"
            [readonly]="!isActive"
            autocomplete="off"
          />
          <mat-error *ngFor="let validation of validation_messages.phone">
            <span
              class="mat-error"
              *ngIf="
                myform.get('phone').hasError(validation.type) &&
                (myform.get('phone').dirty || myform.get('phone').touched)
              "
            >
              {{ validation.message.replace('$', this.maxlengthCellNumber) }}</span
            >
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-6 col-md-3" [ngClass]="{ 'col-lg-2': aditional }">
          <mat-label>Escriba el correo *</mat-label>
          <input
            matInput
            type="email"
            id="customerEmail"
            name="email"
            formControlName="email"
            [readonly]="!isActive"
            autocomplete="off"
          />
          <mat-error *ngFor="let validation of validation_messages.email">
            <span
              class="mat-error"
              *ngIf="
                myform.get('email').hasError(validation.type) &&
                (myform.get('email').dirty || myform.get('email').touched)
              "
            >
              {{ validation.message }}</span
            >
          </mat-error>
        </mat-form-field>
        <ng-container *ngIf="aditional" formGroupName="aditional">
          <mat-form-field class="col-6 col-md-3 col-lg-2">
            <mat-label>Tipo de cliente</mat-label>
            <mat-select
              id="customerType"
              formControlName="customerType"
              disableOptionCentering="true"
            >
              <mat-option
                *ngFor="let item of customersType"
                [value]="item['value']"
                >{{ item['text'] }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-6 col-md-3"
            [ngClass]="{ 'col-lg-3': aditional }"
          >
            <mat-label>Forma de pago</mat-label>
            <mat-select
              id="paymentMethod"
              formControlName="paymentMethod"
              disableOptionCentering="true"
              (selectionChange)="onSelectedPayment($event)"
            >
              <mat-option *ngFor="let item of waysToPay" [value]="item['value']" [id]="item['value']">
                {{ item['viewValue'] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <section class="col-6 col-md-3 col-xl-1">
            <mat-checkbox id="deferredPayment" formControlName="deferredPayment" [disabled]="isDeferredPayment">Pago Diferido</mat-checkbox>
          </section>
          <!-- <p>{{deferredPayment}} -{{isDeferredPayment}} - {{myform.value['deferredPayment']}}</p> -->
          <mat-form-field class="col-6 col-md-3 col-lg-2 col-xl-2 ">
            <mat-label>Linea de crédito</mat-label>
            <input
              matInput
              type="text"
              id="expirationStatus"
              name="alphabetical"
              formControlName="expirationStatus"
              readonly
            />
          </mat-form-field>
          <mat-form-field class="col-6 col-md-3 col-xl-2">
            <mat-label>{{' Crédito disponible ' + currencyCode + '/'}}</mat-label>
            <input
              matInput
              type="text"
              id="availableCreditText"
              name="alphabetical"
              formControlName="availableCreditText"
              readonly
            />
            <mat-hint *ngIf="!myform.value['aditional']['availableCreditText']">
              <mat-error>No puede generar una cotización con crédito cero</mat-error></mat-hint>
          </mat-form-field>

          <mat-form-field class="col-1 col-md-1" *ngIf="showInputCredits">
            <mat-label>N° cuotas</mat-label>
            <mat-select
              id="numberInstallments"
              name="alphabetical"
              formControlName="numberInstallments"
            >
              <mat-option *ngFor="let option of numberInstallmentsOptions" [value]="option.value">
                {{ option.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <mat-form-field
          *ngIf="showInputCredits"
          class="col-6 col-md-3"
          [ngClass]="{ 'col-lg-3': aditional }"
        >
          <mat-label>Opción diferido</mat-label>
          <mat-select
            id="numberDeferredInstallments"
            formControlName="numberDeferredInstallments"
            disableOptionCentering="true"
          >
           <mat-option *ngFor="let item of optionCreditConfig" [value]="item['value']" [id]="item['value']">
              {{ item['description'] }}
            </mat-option>
          </mat-select>
        </mat-form-field>


        </ng-container>
        @if (isHESACompany) {
          <section class="col-6 col-md-2 col-xl-1 d-flex align-items-center">
              <mat-checkbox
                id="companySalesEnabled"
                formControlName="companySalesEnabled">Venta Empresa</mat-checkbox>
            </section>
          }
      </div>
    </div>
    <div class="cart-customer" *ngIf="!aditional">
      <mat-checkbox
        id="customerAddPerson"
        (change)="onChangeCheckbox($event.checked)"
        >
        Solicitar recojo/recepción por otra persona
      </mat-checkbox>
      <div class="container-form-receiver form-row" *ngIf="pickPerson">
        <mat-form-field class="col-md-6">
          <mat-label>Documento *</mat-label>
          <input
            matInput
            type="text"
            id="customerNumberTwo"
            name="numberTwo"
            formControlName="documentAditional"
            autocomplete="off"
          />
          <mat-error
            *ngIf="myform.get('documentAditional')?.errors?.['maxlength']"
          >
            Máximo {{ myform.get('documentAditional')?.errors?.['maxlength']?.['requiredLength'] }} caracteres
          </mat-error>

          <mat-error
            *ngIf="myform.get('documentAditional')?.errors?.['required']"
          >
            Campo obligatorio
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Nombre - descripción *</mat-label>
          <input
            matInput
            id="customerNameTwo"
            name="alphabetical"
            formControlName="nameAditional"
            autocomplete="off"
          />
            <mat-error *ngIf="myform.get('nameAditional')?.errors?.['maxlength']">
              Máximo {{myform.get('nameAditional')?.errors?.['maxlength']?.['requiredLength']}} caracteres
            </mat-error>
            <mat-error *ngIf="myform.get('nameAditional')?.errors?.['required']">
              Campo obligatorio
            </mat-error>
        </mat-form-field>
        <mat-error
          class="error-info"
          *ngIf="
            !myform.valid
          "
        >
          Si solicita recojo por tercera persona, es obligatorio llenar los
          campos requeridos
        </mat-error>
      </div>
    </div>
  </form>
</mat-expansion-panel>
